import * as React from 'react';
import { Grid } from '@mui/material';
import RuntimeMetricDetails from './RuntimeMetricDetails';

type SideBarContentProps = {
  runtimeMetric: any;
};

const RuntimeMetricSidebarContent: React.FC<SideBarContentProps> = (props) => {
  const { runtimeMetric } = props;

  return (
    <>
      <Grid
        justifyContent="space-between"
        container
        spacing={3}
        style={{ marginLeft: '0px', marginTop: '0px', paddingRight: '50px' }}
      >
        <Grid item xs={12}>
          <RuntimeMetricDetails runtimeMetric={runtimeMetric} />
        </Grid>
      </Grid>
    </>
  );
};

export default RuntimeMetricSidebarContent;
